module.exports = __webpack_public_path__ + "static/media/credit-card-selected.b60db17e.svg";